import currencyFormatter from '~/utils/currencyFormatter';

import type { PricingToolTab } from './types';

// Order matches the mockup's card sequence. Preferred Option/Margin live inside Package Options;
// Export is a toolbar action, not a tab.
export const PRICING_TOOL_TABS: Array<{ label: string; value: PricingToolTab }> = [
  { label: 'Property Setup', value: 'property-setup' },
  { label: 'Package Options', value: 'package-options' },
  { label: 'Inclusions', value: 'inclusions' },
  { label: 'Pricing Summary', value: 'pricing-summary' },
  { label: 'Blackouts', value: 'blackouts' },
  { label: 'Surcharges', value: 'surcharges' },
  { label: 'EGS', value: 'egs' },
  { label: 'Overrides', value: 'overrides' },
  { label: 'Forecasting', value: 'forecasting' },
];

export function getPricingToolTab(tab: string | null | undefined): PricingToolTab {
  return PRICING_TOOL_TABS.some((pricingToolTab) => pricingToolTab.value === tab)
    ? (tab as PricingToolTab)
    : 'property-setup';
}

type PricingToolTabEntry = (typeof PRICING_TOOL_TABS)[number];

export function getAdjacentPricingToolTabs(tab: PricingToolTab): {
  previous?: PricingToolTabEntry;
  next?: PricingToolTabEntry;
} {
  const index = PRICING_TOOL_TABS.findIndex((pricingToolTab) => pricingToolTab.value === tab);
  return { previous: PRICING_TOOL_TABS[index - 1], next: PRICING_TOOL_TABS[index + 1] };
}

export const PRICING_OPTION_LABELS = ['Option 1', 'Option 2', 'Option 3'];

export const audMoney = (value: number) => currencyFormatter('AUD', value, 2);

export const SALESFORCE_FIELD_MAX_LENGTH = {
  inclusionName: 80,
  assetName: 255,
  dealOptionName: 80,
  blackoutName: 80,
  surchargeName: 80,
  overrideName: 80,
  egsRoomName: 80,
} as const;

export function exceedsFieldLength(value: string | undefined, maxLength: number): boolean {
  return (value?.trim().length ?? 0) > maxLength;
}

export function fieldLengthProps(value: string | undefined, maxLength: number) {
  const isTooLong = exceedsFieldLength(value, maxLength);
  return {
    error: isTooLong,
    helperText: isTooLong ? `Too long (${value?.trim().length}/${maxLength})` : undefined,
  };
}

const NAME_PREVIEW_LENGTH = 40;

export const previewName = (name: string) =>
  name.length > NAME_PREVIEW_LENGTH ? `${name.slice(0, NAME_PREVIEW_LENGTH)}…` : name;
